export function buildTerminalTheme(root = typeof document !== "undefined" ? document.documentElement : undefined) {
    const styles = root ? getComputedStyle(root) : undefined;
    const token = (name, fallback) => {
        const value = styles?.getPropertyValue(name).trim();
        return value || fallback;
    };
    return {
        background: token("--fwfa-terminal-bg", "#001320"),
        foreground: token("--fwfa-terminal-fg", "#ccd4d7"),
        cursor: token("--fwfa-terminal-cursor", "#fec601"),
        cursorAccent: token("--fwfa-terminal-bg", "#001320"),
        selectionBackground: token("--fwfa-terminal-selection", "rgba(255, 255, 255, 0.16)"),
        black: token("--fwfa-terminal-ansi-black", "#0a2138"),
        red: token("--fwfa-terminal-ansi-red", "#ff5a3c"),
        green: token("--fwfa-terminal-ansi-green", "#6cbe45"),
        yellow: token("--fwfa-terminal-ansi-yellow", "#fec601"),
        blue: token("--fwfa-terminal-ansi-blue", "#77bddb"),
        magenta: token("--fwfa-terminal-ansi-magenta", "#c77dbb"),
        cyan: token("--fwfa-terminal-ansi-cyan", "#6fd3c6"),
        white: token("--fwfa-terminal-ansi-white", "#ccd4d7"),
        brightBlack: token("--fwfa-terminal-ansi-bright-black", "#335561"),
        brightRed: token("--fwfa-terminal-ansi-bright-red", "#ff7a52"),
        brightGreen: token("--fwfa-terminal-ansi-bright-green", "#8fd86b"),
        brightYellow: token("--fwfa-terminal-ansi-bright-yellow", "#ffd84d"),
        brightBlue: token("--fwfa-terminal-ansi-bright-blue", "#a0d4e8"),
        brightMagenta: token("--fwfa-terminal-ansi-bright-magenta", "#d9a0d0"),
        brightCyan: token("--fwfa-terminal-ansi-bright-cyan", "#97e0d6"),
        brightWhite: token("--fwfa-terminal-ansi-bright-white", "#ffffff"),
    };
}
//# sourceMappingURL=terminal.js.map